<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title"><span class="bold">ACE OF THE BLACK CROSS</span></h1>
<p class="titlea">ERNST UDET</p>
<p class="author"><em class="italic">Introduction by</em></p>
<p class="author">RICHARD OVERY</p>
<div class="image_containerf">
<img alt="images" src="images/f0iii-01.jpg" style="width:50%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?136c54c0